import { SearchX } from "lucide-react";
import TrendingSearches from "@/theme1/components/search/TrendingSearches";
import SearchCategories from "@/theme1/components/search/SearchCategories";

export default function EmptySearch({
  query,
  onSearch,
  onSelect,
  trendingSearches,
  searchCategories,
}) {
  return (
    <div className="rounded-3xl border border-border bg-neutral-100/30 p-8 text-center">
      <SearchX className="mx-auto size-8 text-muted-foreground" />

      <h3 className="mt-4 text-xl font-semibold tracking-tight">
        No results for “{query}”
      </h3>

      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-muted-foreground">
        Try searching for a product, collection, color, or category.
      </p>

      <div className="mt-8 space-y-6 text-left">
        <TrendingSearches
          trendingSearches={trendingSearches}
          onSearch={onSearch}
        />
        <SearchCategories
          categories={searchCategories}
          onSelect={onSelect}
        />
      </div>
    </div>
  );
}
